/**
 * DESERTLAND.content.Home
 */
import { App } from '../desertland.app';
import { Utils } from '../cals.utils';
import { ROUTES } from '../desertland.router';
// import { Plants } from '../desertland.plants';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.template';

/* tslint:disable variable-name prefer-for-of */
declare var log, info, warn, groupCollapsed, groupEnd;


export class HomeContent {
  public page = ROUTES.HOME;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-home';
  public featuredSel = "#tmpl_inject_featured_plants";
  public featuredTag = "tpl-featured-plants";
  public featuredItemSel = "#tmpl_featured_plants";
  public contentNavSel = "#tmpl_inject_main_content_nav";
  public contentNavTag = "tpl-main-content-nav";

  public plantsReady = false;
  public featuredRendered = false;

  public init() {
    groupCollapsed("Home.init");
    //this.bSubTplsReady = false;

    // info('data.plants',App.data.plants);

    if (App.data.plants && App.data.plants.length > 0) {
      info("plant data ready", App.data.plants);
      this.plantsReady = true;
    } else {
      info("plant data not ready yet", App.data.plants);
      this.plantsReady = false;
      // App.radio.subscribe('dataPlantsReady', this.onPlantsDataReady);
      App.plants.fetchDataThen((data) => {
        // DESERTLAND.radio('dataPlantsReady').broadcast(data).unsubscribe(DESERTLAND.Content.Home.onPlantsDataReady);
        // App.radio.publish('dataPlantsReady', data);
        this.onPlantsDataReady(data);
      });
    }

    if ($(this.container).length) {
      log("ready for home");
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log("home dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("Home.init");
  }

  public loadTpl(callback) {
    log("Home > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log("Home > renderTpl sel:", resp.sel, resp);
      if (resp && resp.sel && $(resp.sel).length) {
        // log($(resp.sel));
        // log($(resp.sel).html());
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
        App.templates.loadFeaturedAndHomeNav(this.contentNavSel, this.featuredSel, this.subTplsReady, this.renderFeatured);


        // create the plants link
        let linkViewModel = kendo.observable({
          link: "/#/" + ROUTES.PLANTS
        });
        kendo.bind($("#home_plant_link"), linkViewModel);
  
      } else {
        info("no sel?");
      }
    });
  }

  public subTplsReady = (tags) => {
    // var me = DESERTLAND.Content.Home;
    log('Home > subTplsReady', tags);//ids of script tags

    //tmpl_inject_main_content_nav
    //tmpl_inject_featured_plants
    //var featuredPlants = new kendo.View("<span>Detail - press your browser back button to navigate back.</span>");
    //me.bSubTplsReady = true;

    if (!this.featuredRendered && this.plantsReady) {
      this.renderFeatured();
    }

    Utils.smoothScrollTo('top');
  }

  public onPlantsDataReady = (data = {}) => {
    log("onPlantsDataReady");
    this.plantsReady = true;
    if (!this.featuredRendered) {
      this.renderFeatured(data);
    }
  }

  public renderFeatured = (data = {}) => {
    groupCollapsed("Home > renderFeatured");
    // var me = DESERTLAND.Content.Home;
    // log("renderFeatured", data, this);

    let $tpl = $('#' + this.featuredTag),
      $sel = $(this.featuredSel);

    if (!this.plantsReady || !$sel.length || !$tpl.length || !App.data.plants || App.data.plants.length < 1) {
      let s = "featured not ready yet, waiting for: ";

      if (!this.plantsReady) { info(s + "!plantsReady"); }
      if (!$sel.length) { info(s + "!sel.len"); }
      if (!$tpl.length) { info(s + "!tpl.len"); }
      if (!App.data.plants) { info(s + "!data.plants", App.data.plants); }

    } else {
      info("ok, ready...");//, App.data.plants);
      this.featuredRendered = true;

      let getFeat = function (o) {
        if (o.featured && o.featured_title) {
          return o.featured === "1" && o.featured_title.length > 0;
        }
        return false;
      };
      let feat = App.data.plants.filter(getFeat);
      info('featured:', feat);

      if (feat && feat.length > 0) {

        //create container
        const _itemTemplate = kendo.template($tpl.html(), { useWithBlock: false });
        let result = _itemTemplate({ App });//Pass the data to the compiled template // tslint required data param 2018 oct

        $sel.fadeOut(200, () => {
          groupCollapsed("Home > renderFeatured > items");
          //$sel.find(".loader-wrap").hide();
          $sel.empty().append(result);

          let $wrap = $sel.find(this.featuredItemSel);

          if ($wrap.length) {
            $wrap.empty();

            // sampleit
            feat = Utils.getRandomSubarray(feat, 4);

            for (let i = 0; i < feat.length; i++) {
              this.renderFeatItem(feat[i], $wrap);
            }

          } else {
            info("no wrap - hide");
            $sel.hide();
          }

          $sel.fadeIn(400);
          groupEnd("Home > renderFeatured > items");
        });//end fadeout complete


      } else {
        info("no results - hide");
        $sel.hide();
      }
    }
    groupEnd("Home > renderFeatured");
  }

  public renderFeatItem(data, $container) {
    log("Home > renderFeatItem %o", data);
    data.Utils = Utils;
    data.Config = App.config;

    //var catName = Utils.changeSpacesToDashes(data.cat_name).toLowerCase();
    /*
                        <div class="col-xs-6 col-md-3">
                            <div class="featured-plant">
                                <div class="img-abs-top-content bg-black-trans text-center">
                                    The Director of The UA Arboretum's Favorite
                                </div>
                                <img class="img-responsive" src=" data.siteRoot /images/placeholder.jpg" alt="Featured Plant"/>
                                <div class="img-infobox infobox-bottom brown-bg">
                                    <div class="common-name">
                                        Common Name
                                    </div>
                                    <div class="botanical-name">
                                        <em>Botanical Name</em>
                                    </div>
                                    <div class="plant-type">
                                        Type
                                    </div>
                                </div>
                            </div>
                        </div>
    */

    let tplStr = '<div class="col-xs-6 col-md-3">'
      + '<div class="featured-plant">'
      + '<a href="/\\#/plant/#: nid #/#= data.Utils.changeSpacesToDashes(common_name) #" title="See Plant Details: #= common_name #">'
      + '<div class="img-abs-top-content bg-black-trans text-center">#= featured_title #</div>'
      //+ '<img class="img-responsive" src="#= DESERTLAND.config.img_url.plant #/#= image #" alt="Featured Plant"/>'
      + '<div class="featured-img" style="background-image:url(#= Config.img_url.plant #/#= image #)" />'
      + '<div class="img-infobox infobox-bottom">'
      + '<div class="common-name">#= common_name #</div>'
      + '<div class="botanical-name"><em>#= botanical_name #</em></div>'
      + '<div class="plant-type">#= plant_group #</div>'
      + '</div>'
      + '</a>'
      + '</div>'
      + '</div>';

    let template = kendo.template(tplStr),
      result = template(data);
    $container.append(result);

  }


}

